import fetchUser from './fetchUser';
import postAuthToken from './postAuthToken';

/**
 * Login retrieves auth tokens and then fetches the user information.
 * @param {string} email - The user account email
 * @param {string} password - The user account password
 * @param {string} [application] - Optional login target for app-scoped auth rules
 */
export const login = (email, password, application) => async dispatch => {
  const tokensAction = await dispatch(
    postAuthToken(email, password, application),
  );
  if (tokensAction.error) {
    throw tokensAction.error;
  }
  // The optional application only scopes token-auth rules. User normalization
  // stays on the legacy portal path; product apps such as REC select their own
  // organization from the returned profile after login.
  const userAction = await dispatch(fetchUser());
  if (userAction.error) {
    throw userAction.error;
  }
  return userAction.profile;
};

export default login;
